<div *ngIf="showPendingJoiners">
  <h6 class="cursor-default font-weight-light pl-4">{{ 'orgprojectpendingjoinerlist.title' | trans }}</h6>
  <p class="cursor-default pl-4">{{ 'orgprojectpendingjoinerlist.subtitle' | trans }}</p>

  <div *ngFor="let joiner of pendingjoiners" class="row pl-4 pt-1 p-3 pb-2">
    <div class="col"><a matTooltip="{{ 'orgprojectpendingjoinerlist.showdetailsof' | trans }}" matTooltipPosition="above" matTooltipShowDelay="1000">
      <p class="cursor-pointer font-weight-light">{{ joiner.fullname }}</p></a></div>
    <div class="col"><p class="">{{ joiner.date_showed_interest | date:'yyyy-MM-dd'  }}</p></div>
    <div class="col"><p class="">{{ joiner.phone }}</p></div>
    <div class="col"><p class="">{{ joiner.im }}</p></div>
    <div class="col">
      <div *ngIf="canChangeAcceptDecline" class="row">
        <div class="col">
          <button class="btn-empty border-0" (click)="declinePendingJoiner(joiner)"></button>
          <span matTooltip="{{ 'orgprojectpendingjoinerlist.decline' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons c-close cursor-pointer zoom">
            cancel
            </span>
        </div>
        <div class="col">
          <button data-toggle="modal" (click)="setModalPerson(joiner)" data-target="#assignRole" class="btn-empty border-0">
            <span matTooltip="{{ 'orgprojectpendingjoinerlist.accept' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons c-save cursor-pointer zoom">
              check_circle
              </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>